import { BodyBox, EntityForm } from '@lbcamden/lib-react';
import { FunctionComponent, useMemo } from 'react';

import { PageBreadcrumbs } from '~/client/components/shared/PageBreadcrumbs';
import { useUserStore } from '~/client/hooks/storeHooks';
import { useGoBackOrNavigate } from '~/client/hooks/useGoBackOrNavigate';
import { getPropertyBreadcrumbs, toPersonPage } from '~/client/utils/navigation';
import { contactDetailsFormSchema } from '~/common/schemas/people';

import { LoadInNotFoundPage } from '../../LoadInNotFoundPage';
import { usePersonFromPath } from '../usePersonFromPath';
import { contactDetailsFormConfig, ContactDetailsFormValues } from './config';
import { formValuesToUpdatePayload, getInitialFormValues } from './helpers';

const title = 'Edit contact details';

export const ContactDetailsEditPage: FunctionComponent = () => {
  const navigate = useGoBackOrNavigate();

  const { property, person } = usePersonFromPath();
  const userStore = useUserStore();

  const initialFormValues = useMemo(() => getInitialFormValues(person), [person]);

  if (!property || !person) {
    return <LoadInNotFoundPage />;
  }
  const { propertyId, personId } = person;

  const goToPersonPage = () => navigate(toPersonPage(propertyId, personId));

  const onSave = (values: ContactDetailsFormValues) => {
    const payload = formValuesToUpdatePayload(person, values);
    userStore?.handleAndDispatchMessage('updateContactDetails', personId, payload);
    void goToPersonPage();
  };

  return (
    <BodyBox>
      <PageBreadcrumbs
        css={{ marginBottom: 0 }}
        links={[
          ...getPropertyBreadcrumbs(property),
          { link: toPersonPage(propertyId, personId), name: person.fullName },
          { name: title },
        ]}
      />
      <EntityForm
        title={`${person?.fullName} - ${title}`}
        schema={contactDetailsFormSchema}
        config={contactDetailsFormConfig}
        initialValue={initialFormValues}
        onCancel={goToPersonPage}
        onSave={onSave}
      />
    </BodyBox>
  );
};
